import React from 'react';
import Image from 'next/image';

const ValuePropositionVisionMultimodal = () => {
    return (
        <div className="section-py relative bg-black">
                    <div className="bg-agriculture-numbers">
                    <video playsInline autoPlay muted loop className="aimlvideo h-[385px] counter-overlay-value" width="100%">
                        <source src="media/aiml-section.mp4" type="video/mp4" />
                    </video>
                    </div>
                    <div className="container xl:container mx-auto relative z-[1]">
                        <div className="row grid lg:grid-cols-12 mb-10">
                            <div className="lg:col-span-8 grid">
                                <h2 className="text-white mb-2.5">
                                    Value Proposition
                                </h2>
                                <p className='dark:text-[#D7DEE5] mb-0'>
                                    We help enterprises unlock the full potential of Computer Vision & Multimodal AI to automate visual inspection, enhance customer experiences, and accelerate decision-making. Built for manufacturing, healthcare, retail, and logistics teams, our solutions deliver measurable impact through production-ready models, secure integrations, and scalable MLOps infrastructure.
                                </p>
                            </div>
                        </div>
                        <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
                            <div>
                                <div className="voice-generator-box mb-2">
                                <Image
                                    src="/img/llms-aiml/svg/ic_theproblemwesolve.svg"
                                    alt="supply-chain-changing"
                                    title="supply-chain-changing"
                                    width={36}
                                        height={36}
                                />
                                </div>
                                <p className="text-white mb-2 font-bold">The problem we solve</p>
                                <p className="text-white opacity-[0.8] mb-0 fs-md">
                                    Manual visual inspection, unstructured document processing, and fragmented data sources cause quality inconsistencies, slow turnaround times, and missed insights across image, video, and sensor streams.
                                </p>
                            </div>
                            <div>
                                <div className="voice-generator-box mb-2">
                                <Image
                                    src="/img/llms-aiml/svg/ic_ourcorecapabilities.svg"
                                    alt="supply-chain-changing"
                                    title="supply-chain-changing"
                                   width={36}
                                        height={36}
                                />
                                </div>
                                <p className="text-white mb-2 font-bold">Core capabilities</p>
                                <p className="text-white opacity-[0.8] mb-0 fs-md">
                                    Custom computer vision models, object detection, segmentation, classification, OCR, multimodal AI, edge deployment, document intelligence, video analytics, fine-tuning YOLO, SAM, CLIP, Florence, Detectron2.
                                </p>
                            </div>
                            <div>
                                <div className="voice-generator-box mb-2">
                                <Image
                                    src="/img/llms-aiml/svg/ic_outcomeexamples.svg"
                                    alt="supply-chain-changing"
                                    title="supply-chain-changing"
                                    width={36}
                                        height={36}
                                />
                                </div>
                                <p className="text-white mb-2 font-bold">Outcomes</p>
                                <p className="text-white opacity-[0.8] mb-0 fs-md">
                                   Enhanced operational efficiency, reduced errors, accelerated decision-making, and actionable, scalable insights from visual and multimodal data streams for enterprises.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
    );
};
export default ValuePropositionVisionMultimodal;
